<template>
    <div id="create-account-observer">
        <div class="row m-0" style="width:100%;">
            <div class="col-lg-5 p-0">
                <div class="d-none d-lg-block">
                    <div class="row" id="left-div">
                        <div class="col-md-6" id="cover-img"></div>
                        <div class="col-md-6 p-5 cover-info">
                            <div>
                                <h1 class="mb-5">BECOME AN OBSERVER</h1>
                                <h2 class="mb-4">
                                    JOIN THE WILDLIFE PROTECTOR PRIVATE
                                    MEMBERSHIP
                                </h2>
                                <p>
                                    Be an observer and stay in the lookout for
                                    the latest updates and news about wildlife,
                                    their environment, and WWF's work.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h1 class="mb-5 mt-5 p-1">BECOME AN OBSERVER</h1>
                </div>
            </div>
            <div class="col-lg-7 p-0" id="create-form">
                <header class="site-header d-none d-md-block">
                    <div class="container">
                        <nav
                            class="navbar navbar-expand-lg navbar-light navbar-offcanvas py-0"
                        >
                            <a class="navbar-brand" href="/">
                                <img
                                    class="navbar-logo"
                                    src="/images/WWF_Logo.jpg"
                                />
                            </a>
                        </nav>
                    </div>
                </header>
                <div class="row" style="width:100%;">
                    <div class="col-md-2"></div>
                    <div class="col-md-8 p-0">
                        <div
                            class="card-body p-5"
                            id="observer-form"
                            v-bind:class="{ 'd-none': otp_code }"
                        >
                            <h1 class="mb-4 text-center text-md-left">
                                CREATE YOUR PRIVATE ACCOUNT
                            </h1>
                            <form @submit.prevent="validateInfo" class="mb-5">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>First name</label>
                                            <input
                                                id="firstname"
                                                type="text"
                                                class="form-control"
                                                value=""
                                                name="firstname"
                                                v-model="fields.firstname"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.firstname
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.firstname"
                                            >
                                                <strong>{{
                                                    errors.firstname
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Last name</label>
                                            <input
                                                id="lastname"
                                                type="text"
                                                class="form-control"
                                                name="lastname"
                                                v-model="fields.lastname"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.lastname
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.lastname"
                                            >
                                                <strong>{{
                                                    errors.lastname
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Email address</label>
                                            <input
                                                id="email"
                                                type="email"
                                                class="form-control"
                                                name="email"
                                                placeholder="example@email.com"
                                                v-model="fields.email"
                                                v-bind:class="{
                                                    'is-invalid': errors.email
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.email"
                                            >
                                                <strong>{{
                                                    errors.email
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Phone number</label>
                                            <vue-tel-input
                                                class="form-control"
                                                name="phone"
                                                v-model="fields.phone"
                                                v-on:input="validate"
                                                v-bind:class="{
                                                    'is-invalid': errors.phone
                                                }"
                                            ></vue-tel-input>
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.phone"
                                            >
                                                <strong>{{
                                                    errors.phone
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Password</label>
                                            <input
                                                id="password"
                                                type="password"
                                                class="form-control"
                                                name="password"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.password
                                                }"
                                                placeholder="Password"
                                                v-model="fields.password"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.password"
                                            >
                                                <strong>{{
                                                    errors.password
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Confirm password</label>
                                            <input
                                                id="password_confirmation"
                                                type="password"
                                                class="form-control"
                                                name="password_confirmation"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.password_confirmation
                                                }"
                                                autofocus
                                                placeholder="Password"
                                                v-model="
                                                    fields.password_confirmation
                                                "
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="
                                                    errors.password_confirmation
                                                "
                                            >
                                                <strong>{{
                                                    errors.password_confirmation
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        class="col-md-12 d-none"
                                        v-if="species.length"
                                    >
                                        <div class="form-group">
                                            <label
                                                class="font-weight-bold"
                                                for=""
                                                >I'm interested in:</label
                                            >
                                            <div>
                                                <ul class="list-inline">
                                                    <li
                                                        class="list-inline-item mr-1 mb-1"
                                                        :class="{
                                                            active: fields.interests.includes(
                                                                specie.id
                                                            )
                                                        }"
                                                        v-for="specie in species"
                                                        :key="specie.id"
                                                        @click="
                                                            toggleInterest(
                                                                specie.id
                                                            )
                                                        "
                                                    >
                                                        <img
                                                            width="75"
                                                            height="75"
                                                            class="rounded-circle"
                                                            :src="
                                                                '/storage/' +
                                                                    specie.image
                                                            "
                                                            :alt="specie.name"
                                                        />
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="form-group ml-4">
                                            <input
                                                type="checkbox"
                                                name="pdpa"
                                                id="pdpa"
                                                class="form-check-input"
                                                v-model="fields.pdpa"
                                            />
                                            <label
                                                for="pdpa"
                                                class="form-check-label"
                                            >
                                                I agree that by completing this
                                                form, WWF-Singapore may use,
                                                collect, disclose and process my
                                                personal information as per its
                                                <a
                                                    href="https://www.wwf.sg/wwf_singapore-pdp_policy/"
                                                >
                                                    Personal Data Protection
                                                    Policy</a
                                                >, and this personal information
                                                that I have provided to
                                                WWF-Singapore is true and
                                                complete to the best of my
                                                knowledge and belief.
                                            </label>
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.pdpa"
                                            >
                                                <strong>{{
                                                    errors.pdpa
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group row mb-0 mt-3">
                                    <div class="col-md-3"></div>
                                    <div class="col-md-3"></div>
                                    <div class="col-md-6 col-ls-5">
                                        <button
                                            type="submit"
                                            class="btn btn-primary form-control"
                                        >
                                            NEXT
                                        </button>
                                        <br />
                                        <p
                                            style="padding-top:10px;font-size:0.8rem!important;text-align:right;"
                                        >
                                            Have an account?
                                            <a
                                                href="/login"
                                                class="d-block"
                                                style="color: #3490dc;"
                                                >Sign in</a
                                            >
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <a
                                            href="/auth/google"
                                            class="btn btn-dark btn-block"
                                            style="background: #fff; color: #000;"
                                        >
                                            <svg
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                viewBox="0 0 512 512"
                                                xml:space="preserve"
                                                width="24"
                                                style="margin-right: 10px"
                                            >
                                                <path
                                                    style="fill:#FBBB00;"
                                                    d="M113.47,309.408L95.648,375.94l-65.139,1.378C11.042,341.211,0,299.9,0,256
	c0-42.451,10.324-82.483,28.624-117.732h0.014l57.992,10.632l25.404,57.644c-5.317,15.501-8.215,32.141-8.215,49.456
	C103.821,274.792,107.225,292.797,113.47,309.408z"
                                                />
                                                <path
                                                    style="fill:#518EF8;"
                                                    d="M507.527,208.176C510.467,223.662,512,239.655,512,256c0,18.328-1.927,36.206-5.598,53.451
	c-12.462,58.683-45.025,109.925-90.134,146.187l-0.014-0.014l-73.044-3.727l-10.338-64.535
	c29.932-17.554,53.324-45.025,65.646-77.911h-136.89V208.176h138.887L507.527,208.176L507.527,208.176z"
                                                />
                                                <path
                                                    style="fill:#28B446;"
                                                    d="M416.253,455.624l0.014,0.014C372.396,490.901,316.666,512,256,512
	c-97.491,0-182.252-54.491-225.491-134.681l82.961-67.91c21.619,57.698,77.278,98.771,142.53,98.771
	c28.047,0,54.323-7.582,76.87-20.818L416.253,455.624z"
                                                />
                                                <path
                                                    style="fill:#F14336;"
                                                    d="M419.404,58.936l-82.933,67.896c-23.335-14.586-50.919-23.012-80.471-23.012
	c-66.729,0-123.429,42.957-143.965,102.724l-83.397-68.276h-0.014C71.23,56.123,157.06,0,256,0
	C318.115,0,375.068,22.126,419.404,58.936z"
                                                />
                                            </svg>
                                            Login with Google</a
                                        >
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <a
                                            href="/auth/facebook"
                                            class="btn btn-dark btn-block"
                                            style="background: #fff; color: #000;"
                                        >
                                            <svg
                                                height="24"
                                                width="24"
                                                viewBox="0 0 512 512"
                                                xmlns="http://www.w3.org/2000/svg"
                                                style="margin-right: 10px;"
                                            >
                                                <path
                                                    d="m483.738281 0h-455.5c-15.597656.0078125-28.24218725 12.660156-28.238281 28.261719v455.5c.0078125 15.597656 12.660156 28.242187 28.261719 28.238281h455.476562c15.605469.003906 28.257813-12.644531 28.261719-28.25 0-.003906 0-.007812 0-.011719v-455.5c-.007812-15.597656-12.660156-28.24218725-28.261719-28.238281zm0 0"
                                                    fill="#4267b2"
                                                />
                                                <path
                                                    d="m353.5 512v-198h66.75l10-77.5h-76.75v-49.359375c0-22.386719 6.214844-37.640625 38.316406-37.640625h40.683594v-69.128906c-7.078125-.941406-31.363281-3.046875-59.621094-3.046875-59 0-99.378906 36-99.378906 102.140625v57.035156h-66.5v77.5h66.5v198zm0 0"
                                                    fill="#fff"
                                                />
                                            </svg>
                                            <span>Login with Facebook</span></a
                                        >
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div
                            class="card-body p-5 d-none"
                            id="otp-form"
                            v-bind:class="{ 'd-block': otp_code }"
                        >
                            <h1 class="mb-4">VERIFY YOUR ACCOUNT</h1>
                            <form @submit.prevent="verifyAccount" class="mb-0">
                                <div class="row">
                                    <div class="col-md-12">
                                        <p>
                                            A 4-digit one-time verification code
                                            has been sent to your phone number.
                                            This helps us confirm your identity
                                            and secure your account.
                                        </p>
                                    </div>
                                    <div class="col-lg-1"></div>
                                    <div
                                        class="col-lg-10 col-md-12 col-sm-12 col-xs-12"
                                    >
                                        <div class="row mt-4">
                                            <div class="col-3 p-1">
                                                <input
                                                    type="number"
                                                    name="code_1"
                                                    ref="code_1"
                                                    class="form-control text-center otp-code p-0"
                                                    onKeyPress="if(this.value.length==1) return false;"
                                                    min="0"
                                                    oninput="validity.valid||(value='');"
                                                    v-on:keyup="
                                                        nextFocus(
                                                            $event.target.value,
                                                            2,
                                                            1
                                                        )
                                                    "
                                                    required
                                                    placeholder="0"
                                                    v-model="otp_codes.code_1"
                                                />
                                            </div>
                                            <div class="col-3 p-1">
                                                <input
                                                    type="text"
                                                    name="code_2"
                                                    ref="code_2"
                                                    class="form-control text-center otp-code p-0"
                                                    onKeyPress="if(this.value.length==1) return false;"
                                                    min="0"
                                                    oninput="validity.valid||(value='');"
                                                    v-on:keyup="
                                                        nextFocus(
                                                            $event.target.value,
                                                            3,
                                                            1
                                                        )
                                                    "
                                                    required
                                                    placeholder="0"
                                                    v-model="otp_codes.code_2"
                                                />
                                            </div>
                                            <div class="col-3 p-1">
                                                <input
                                                    type="text"
                                                    name="code_3"
                                                    ref="code_3"
                                                    class="form-control text-center otp-code p-0"
                                                    onKeyPress="if(this.value.length==1) return false;"
                                                    min="0"
                                                    oninput="validity.valid||(value='');"
                                                    v-on:keyup="
                                                        nextFocus(
                                                            $event.target.value,
                                                            4,
                                                            2
                                                        )
                                                    "
                                                    required
                                                    placeholder="0"
                                                    v-model="otp_codes.code_3"
                                                />
                                            </div>
                                            <div class="col-3 p-1">
                                                <input
                                                    type="text"
                                                    name="code_4"
                                                    ref="code_4"
                                                    class="form-control text-center otp-code p-0"
                                                    onKeyPress="if(this.value.length==1) return false;"
                                                    min="0"
                                                    oninput="validity.valid||(value='');"
                                                    v-on:keyup="
                                                        nextFocus(
                                                            $event.target.value,
                                                            4,
                                                            3
                                                        )
                                                    "
                                                    required
                                                    placeholder="0"
                                                    v-model="otp_codes.code_4"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-1"></div>
                                </div>

                                <div class="form-group row mb-3 mt-5">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            type="submit"
                                            id="GAtrigger"
                                            class="btn btn-primary form-control"
                                        >
                                            SUBMIT
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
            <div class="col-12 p-0">
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h2 class="mb-1 p-1">
                        JOIN THE WILDLIFE PROTECTOR PRIVATE MEMBERSHIP
                    </h2>
                    <p class="mb-2 p-5">
                        Be an observer and stay in the lookout for the latest
                        updates and news about wildlife, their environment, and
                        WWF's work.
                    </p>
                    <div id="cover-img" style="height:80vh; width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["token", "utm", "species", "firstname", "lastname", "email"],
    data() {
        return {
            fields: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                password: "",
                pdpa: false,
                donor: false,
                interests: [],
                password_confirmation: "",
                clean_phone_format: "",
                _token: this.token
            },
            otp_code: "",
            otp_codes: {
                code_1: "",
                code_2: "",
                code_3: "",
                code_4: ""
            },
            errors: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                pdpa: "",
                password: "",
                password_confirmation: ""
            }
        };
    },
    create() {
        // console.log(this.utm);
    },
    methods: {
        toggleInterest(interest_id) {
            if (this.fields.interests.includes(interest_id)) {
                this.fields.interests.splice(
                    this.fields.interests.indexOf(interest_id),
                    1
                );
                return;
            } else {
                this.fields.interests.push(interest_id);
            }
        },
        validate(number, result) {
            this.errors.phone = result.isValid
                ? ""
                : "The phone number is invalid.";
            this.fields.clean_phone_format = result.isValid
                ? result.number.e164.replace("+", "")
                : "";
        },
        validateInfo() {
            fetch("/create-account-observer/validate-fields", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => res.json())
                .then(res => {
                    if (
                        typeof res.errors != "undefined" ||
                        this.errors.phone != ""
                    ) {
                        this.errors.firstname =
                            typeof res.errors.firstname != "undefined"
                                ? res.errors.firstname[0]
                                : "";
                        this.errors.lastname =
                            typeof res.errors.lastname != "undefined"
                                ? res.errors.lastname[0]
                                : "";
                        this.errors.email =
                            typeof res.errors.email != "undefined"
                                ? res.errors.email[0]
                                : "";
                        this.errors.phone =
                            typeof res.errors.phone != "undefined"
                                ? res.errors.phone[0]
                                : this.errors.phone != ""
                                ? "The phone number is invalid."
                                : "";
                        this.errors.password =
                            typeof res.errors.password != "undefined"
                                ? res.errors.password[0]
                                : "";
                        this.errors.password_confirmation =
                            typeof res.errors.password_confirmation !=
                            "undefined"
                                ? res.errors.password_confirmation[0]
                                : "";
                        this.errors.pdpa =
                            typeof res.errors.pdpa != "undefined"
                                ? res.errors.pdpa[0]
                                : "";
                    } else {
                        this.otp_code = res.otp_code;
                    }
                })
                .catch(err => console.log(err));
        },
        verifyAccount() {
            const otp_code =
                this.otp_codes.code_1 +
                this.otp_codes.code_2 +
                this.otp_codes.code_3 +
                this.otp_codes.code_4;

            if (this.otp_code == otp_code) {
                this.createAccount();
            } else {
                new swal({
                    title: "Oh no!",
                    text: "The OTP code does not match. Please try again.",
                    icon: "error"
                });
            }
        },
        createAccount() {
            this.$gtag.event("generate_lead", {
                currency: "SGD",
                value: 0
            });
            fetch("/create-account-observer", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => res.json())
                .then(res => {
                    if (res.status == "success") {
                        const name =
                            this.fields.firstname + " " + this.fields.lastname;

                        // const userDetails = {
                        //     uniqueId: "user_id_" + res.data.user_id,
                        //     email: this.fields.email,
                        //     phone: this.fields.phone,
                        //     name: name,
                        //     interest: res.data.interest
                        // };

                        // window.ReWebSDK.userRegister(userDetails);

                        let RID_ = null;
                        let CID_ = null;
                        RID_ = GetValues("rid");
                        CID_ = GetValues("cid");

                        if (RID_ == undefined || !RID_) {
                            RID_ = "";
                        }
                        if (CID_ == undefined || !CID_) {
                            CID_ = "";
                        }

                        // var apiData = {
                        //     First_name: this.fields.firstname, // change from First-name
                        //     Last_name: this.fields.lastname, // change from Last-name
                        //     MobileNo: this.fields.phone, // exists
                        //     EmailID: this.fields.email, // exists
                        //     Tags: "FR_Adoption", // exists
                        //     formid: "38", // change value from 5
                        //     apikey: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f", // exists
                        //     SourceURL: getsourceurl(), // exists
                        //     pagereferrerurl: getsourceurl(), // exists
                        //     rid: RID_, // exists
                        //     cid: CID_, // exists
                        //     pagetitle: getpagetitle() // exists
                        // };

                        // let apiData = {
                        //     "First-name": this.fields.firstname,
                        //     "Last-name": this.fields.lastname,
                        //     EmailID: this.fields.email,
                        //     MobileNo: this.fields.phone,
                        //     Password: this.fields.password,
                        //     "Confirm-Password": this.fields
                        //         .password_confirmation,
                        //     formid: "5",
                        //     apikey: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f",
                        //     SourceURL: getsourceurl(),
                        //     pagereferrerurl: "value",
                        //     rid: RID_,
                        //     cid: CID_,
                        //     pagetitle: getpagetitle(),
                        //     Tags: "FR_Adoption"
                        // };

                        var apiData = {
                            First_name: this.fields.firstname, // change from First-name
                            Last_name: this.fields.lastname, // change from Last-name
                            MobileNo: this.fields.phone, // exists
                            EmailID: this.fields.email, // exists
                            Tags: "FR_Adoption_Observer", // exists
                            formid: "38",
                            dbId: "204e7b64_558b_4aa7_9dcc_4e4e7ea7187f",
                            SourceURL: getsourceurl(),
                            pagereferrerurl: getsourceurl(),
                            rid: RID_,
                            cid: CID_,
                            pagetitle: getpagetitle(),
                            Notsubmit: "no"
                        };

                        console.log(apiData);

                        if (
                            this.fields.email?.includes("@wwf") ||
                            (this.fields.email?.includes("rsltks") &&
                                this.fields.email?.includes("dinesh"))
                        ) {
                            let formData = new FormData();

                            formData = this.objectToFormData(apiData);

                            fetch(
                                "https://resu.io/Subscription/IndexInsertAPITemp",
                                {
                                    method: "post",
                                    body: formData
                                }
                            );
                        }

                        const eventData = {
                            eventName: "account_creation",
                            data: {
                                first_name: this.fields.firstname,
                                last_name: this.fields.lastname,
                                email: this.fields.email
                            }
                        };

                        window.ReWebSDK.customEvent(eventData);

                        setTimeout(() => {
                            window.location.href = "/observer/success";
                        }, 10000);
                    }
                })
                .catch(err => console.log(err));
        },
        nextFocus(value, next, prev) {
            if (value) {
                this.$refs["code_" + next].focus();
            } else {
                this.$refs["code_" + prev].focus();
            }
        },

        // Function to add all object properties to FormData
        objectToFormData(obj, formData = new FormData(), parentKey = "") {
            for (let key in obj) {
                if (obj.hasOwnProperty(key)) {
                    // Append the value to FormData
                    formData.append(key, obj[key]);
                }
            }
            return formData;
        }
    },
    mounted() {
        // var url_string = window.location.href;
        // var url = new URL(url_string);
        // this.fields.firstname = url.searchParams.get("firstname");
        // this.fields.lastname = url.searchParams.get("lastname");
        // this.fields.email = url.searchParams.get("email");
        this.fields.firstname = this.firstname;
        this.fields.lastname = this.lastname;
        this.fields.email = this.email;
    }
};
</script>

<style scoped>
header {
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
}
#create-account-observer {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 90vh;
}
#create-account-observer #left-div {
    padding: 0;
    background-color: black;
    min-height: 90vh;
}
#create-account-observer #left-div .col-6 {
    padding: 0;
}
#cover-img {
    background-image: url("/images/pages/checkout/Vertical-Join-Wildlife-Observer.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100vh;
}
.cover-info,
#create-form {
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover-info h1 {
    color: #ffca00;
    font-size: 3rem;
    margin-bottom: 1.5rem !important;
}
.cover-info h2 {
    color: white;
    font-size: 2rem;
}
.btn-orange {
    background-color: #f58220;
    border: none;
    font-size: 1.5rem;
    border-radius: 0 !important;
    font-family: WWF;
    text-transform: uppercase;
}
.cover-info p {
    color: white;
    font-size: 1rem;
}
.cover-info h1,
.cover-info h2 {
    font-family: "WWF";
    line-height: 1;
}
#create-form .card-body {
    box-shadow: 0.2px 0.2px 20px gray;
    border-radius: 3px;
    background-color: white;
}
#create-form .card-body h1 {
    font-family: "WWF";
    font-size: 3em;
    text-align: left;
    line-height: 1;
}
#create-form button {
    background-color: #007798;
    border: none;
    font-weight: bolder;
}
.personal-data-protection-policy {
    color: #f58220;
}
.otp-code {
    font-size: 2.5em;
    font-weight: bolder;
    border-color: #f58220;
    color: #f58220;
    background-color: #f1ebdd;
    border-radius: 0;
}
#loading-message {
    color: #f58220;
}
label {
    font-weight: 400;
    font-family: "Open Sans";
    font-size: 0.9rem;
}
/* SMALL DEVICES */
@media only screen and (min-width: 600px) {
}
/* MEDIUM DEVICES */
@media only screen and (max-width: 992px) {
    #create-account-observer {
        background-color: black;
    }
}

div#observer-form {
    padding: 5rem 2.4rem 2.4rem !important;
}
#create-account-observer p.mb-2.p-5 {
    padding: 1rem 2.4rem 2.4rem !important;
}
#create-account-observer h2.mb-1.p-1 {
    padding-left: 2.4rem !important;
    padding-right: 2.4rem !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
.list-inline-item {
    position: relative;
    cursor: pointer;
}
.list-inline-item img {
    border: 2px solid transparent;
}
.list-inline-item.active img {
    border-color: #222;
}
.list-inline-item.active:after {
    position: absolute;
    top: 5px;
    right: 5px;
    content: "";
    width: 20px;
    height: 20px;
    background-image: url("/images/icons/Tick Mark.svg");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
</style>
